export var EVEN_DISTRIBUTED_COL_WIDTHS = {
  1: 100,
  2: 50,
  3: 33.33,
  4: 25,
  5: 20
};